import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function login(data) {
  return request({
    url: ENDPOINT.LOGIN,
    method: "post",
    data,
  });
}

function updateLoginInfo(data) {
  localStorage.setItem("login_info", JSON.stringify(data));
}

function loginInfo() {
  try {
    return JSON.parse(localStorage.getItem("login_info"));
  } catch (_) {
    return null;
  }
}

function logout() {
  localStorage.removeItem("login_info");
  localStorage.removeItem("all_configs");
  localStorage.removeItem("profiles");
  localStorage.removeItem("current_org");
  window.location.reload();
}

export default {
  login,
  updateLoginInfo,
  loginInfo,
  logout,
};
